import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    main: {
      width: 610,
      maxWidth: '100%',
    },
    dialogTitle: {
      paddingBottom: theme.spacing(3),

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: theme.spacing(1),

      color: theme.palette.error.main,

      '& .MuiTypography-root': {
        color: theme.palette.error.main,
        fontSize: '2.2rem',
        fontWeight: 500,
      },
    },
    dialogContent: {
      backgroundColor: '#F9F9FB',

      '& ul': {
        margin: 0,
        paddingInline: '2.4rem',
      },

      '& li': {
        fontSize: '1.4rem',
      },
    },
    dialogActions: {
      backgroundColor: '#F9F9FB',
      justifyContent: 'space-between',
      paddingRight: theme.spacing(2.2),
      paddingLeft: theme.spacing(2.8),

      '& button': {
        width: 'fit-content',
        height: 36,

        marginTop: 0,
      },
    },
  }),
)
